import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import 'moment/locale/pt-br';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AutenticacaoProvider } from './features/core/contexts/AutenticacaoContext';
import { MenuLateralProvider } from './features/core/contexts/MenuLateralContext';
import { SnackbarProvider } from './features/core/contexts/SnackbarContext';
import { AppThemeProvider } from './features/core/contexts/ThemeContext';
import { CoreRoutes } from './features/core/routes/index';
import GlobalStyles from './features/core/styles/globalStyle';
import { WebSocketPedidosProvider } from './features/pedidos/contexts/WebSocketPedidosContext';
import { WebSocketKDSProvider } from './features/cozinha/contexts/WebSocketKDSContext';
import { NotificacoesProvider } from './features/core/contexts/NotificacoesContext';
import { WebSocketAtendimentoProvider } from './features/pedidos/contexts/atendimento/WebSocketAtendimentoContext';

function App() {
    return (
        <BrowserRouter>
            <AutenticacaoProvider>
                <AppThemeProvider>
                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
                        <SnackbarProvider>
                            <MenuLateralProvider>
                                <NotificacoesProvider>
                                    <WebSocketPedidosProvider>
                                        <WebSocketKDSProvider>
                                            {/* Conexão do atendimento acima das rotas: o badge de
                                                conversas não lidas atualiza em qualquer tela. */}
                                            <WebSocketAtendimentoProvider>
                                                <GlobalStyles />
                                                <CoreRoutes />
                                            </WebSocketAtendimentoProvider>
                                        </WebSocketKDSProvider>
                                    </WebSocketPedidosProvider>
                                </NotificacoesProvider>
                            </MenuLateralProvider>
                        </SnackbarProvider>
                    </LocalizationProvider>
                </AppThemeProvider>
            </AutenticacaoProvider>
        </BrowserRouter>
    );
}

export default App;
